// extracted by mini-css-extract-plugin
export default {"memberCard":"styles_memberCard__8RQ7q","abscentIcon":"styles_abscentIcon__BogUI"};